module.exports = __webpack_public_path__ + "static/media/map-marker.c69c8138.svg";